import { connect } from "react-redux";

import Cart from "./cart";
import { getCartStatus, getCartData } from "./store/selectors";
import {
  getParentCodesStatus,
  getParentCodesData,
} from "../orderBuilder/store/selectors";
import {
  addOrderToCart,
  getParentCodes,
} from "../orderBuilder/store/action-creators";
import { setIsStockOrder } from "../storeHome/store/action-creators";
// import { loadCart } from './store/action-creators';

const mapStateToProps = (state) => ({
  cartStatus: getCartStatus(state),
  cartData: getCartData(state),
  parentCodesData: getParentCodesData(state),
  parentCodesStatus: getParentCodesStatus(state),
});

const mapDispatchToProps = {
  addOrderToCart,
  setIsStockOrder,
  getParentCodes,
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
